import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing } from 'src/types/columnFlags';
const controlledActions = {
    create: [503],
    fetch: [504],
    update: [505],
    delete: [506],
    downloadList: [504],
    uploadList: [503]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'name' }
    ];
};
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName: 'ci.class_rooms',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Classrooms'
});
export default localEntity;
